export default __webpack_public_path__ + "static/media/gallery-wip-steel-core_01.4f0f2fb6.jpg";